import { put, take, fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import { normalize } from 'normalizr';

import * as api from 'api';
import * as actions from 'actions';
import * as schemas from 'schemas';

export function* watchForFeedFetchSuccess() {
  while(true) { // eslint-disable-line no-constant-condition
    const fetchAction = yield take(actions.FEED_FETCH_SUCCESS);
    const feedItems = fetchAction.result.feedItems;

    const feedGoals = feedItems.find(feedItem => feedItem.goals);
    const feedQuestionnaire = feedItems.find(feedItem => feedItem.questionnaire);
    const feedArticles = feedItems.filter(feedItem => feedItem.article);

    if (feedGoals) {
      const normalizedGoals = normalize(feedGoals.goals.goals, schemas.goalsArraySchema);
      yield put(actions.goalsFetchSuccess({
        goalIds: normalizedGoals.result,
        entities: {
          goals: normalizedGoals.entities.goals
        }
      }));
    }

    if (feedQuestionnaire) {
      const { result, entities } = normalize(feedQuestionnaire.questionnaire, schemas.questionnaireSchema);
      yield put(actions.feedQuestionnairesReceived({ feedQuestionnairesIds: result, entities }));
    }

    if (feedArticles) {
      const normalizedArticles = normalize(feedArticles.map(article => article.article), schemas.magazineArticlesArraySchema);
      yield put(actions.magazineArticlesReceived({
        magazineArticlesIds: normalizedArticles.result,
        entities: {
          magazineArticles: normalizedArticles.entities.magazineArticles
        }
      }));
    }

    yield put(actions.feedReceived(fetchAction.page, fetchAction.isManualFetch, fetchAction.result));
  }
}

export function* watchForFeedRefetch() {
  while(true) { // eslint-disable-line no-constant-condition
    yield take([
      actions.JOURNAL_ENTRY_CREATE_SUCCESS,
      actions.FEED_QUESTIONNAIRE_SUBMIT_SUCCESS
    ]);
    yield put(actions.feedFetch());
  }
}

export function* watchForFeedQuestionnaireSucessfulSubmission() {
  while(true) { // eslint-disable-line no-constant-condition
    yield take(actions.FEED_QUESTIONNAIRE_SUBMIT_SUCCESS);
    yield put(actions.infoShow('success', 'You have succesfully submitted your answers!'));
  }
}

export default function* backgroundSaga(socket, request) {
  yield [
    fork(takeLatest, actions.FEED_FETCH, request(api.feedFetch, 'page')),
    fork(takeLatest, actions.FEED_QUESTIONNAIRE_SUBMIT, request(api.feedQuestionnaireSubmit, 'feedQuestionnaire')),
    fork(watchForFeedFetchSuccess),
    fork(watchForFeedQuestionnaireSucessfulSubmission),
    fork(watchForFeedRefetch)
  ];
}



/** WEBPACK FOOTER **
 ** ./src/members/state/feed/sagas.js
 **/